import axiosIns from "@/libs/axios";

const url = "/users";

export async function getUser() {
  return axiosIns.get(`${url}/me`);
}
